import { ITableConfig, ITableRowConfig } from 'components/Table/types';

const rowConfigs: ITableRowConfig[] = [
  { header: 'Model Name', flexValue: 1 },
  { header: 'Model ID', flexValue: 1 },
  { header: 'Version', flexValue: 1 },
];

export const tableConfig: ITableConfig = {
  rowConfigs: rowConfigs,
  extraActionsFlexValue: 1,
};

export const MODELS_PER_PAGE = 10;
